import { apiInstance, gql } from "@/services/httpAdapter";

// Interfaces
import { GraphqlQueryResponse } from "@/Common/api/types/GraphqlQueryResponse";

// Helpers
import { errorLogger } from "@/Common/helpers/logger";

export async function requestUpdatePeriodPayrollProviders(args: { locationId: string; payPeriodsIds: string[] }) {
	const { locationId, payPeriodsIds = [] } = args ?? [];
	const query = gql`
		mutation requestUpdatePeriodPayrollProviders($locationId: String!, $payPeriodsIds: [String]) {
			requestUpdatePeriodPayrollProviders(locationId: $locationId, payPeriodsIds: $payPeriodsIds)
		}
	`;

	const variables = {
		locationId,
		payPeriodsIds,
	};

	try {
		const response: GraphqlQueryResponse<"requestUpdatePeriodPayrollProviders", boolean> = await apiInstance.post("/graphql", {
			query,
			variables,
		});
		return response.data.data?.requestUpdatePeriodPayrollProviders ?? false;
	} catch (err) {
		errorLogger(err as Error);
		return false;
	}
}
